export const updateReseller = `
  mutation updateReseller($input: ResellerAdminInput!) {
    updateReseller(input: $input) {
      ... on ResellerResponse {
        reseller {
          id
        }
      }

      ... on ErrorResponse {
        __typename
        message
        name
      }
    }
  }
`;
